import React from 'react';
import apiclient from 'lib/apiclient';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'reactstrap';

const Table = (props) => {
  const {
    detail
  } = props;
  return (
    <table className='table table-striped' aria-labelledby="tabelLabel">
      <tbody>
      <tr><td>無効</td><td>{detail.void ? 'はい' : 'いいえ'}</td></tr>
      <tr><td>ID</td><td>{detail.id}</td></tr>
      <tr><td>社員番号</td><td>{detail.employeeNumber}</td></tr>
      <tr><td>氏名</td><td>{detail.name}</td></tr>
      <tr><td>エリア</td><td>{detail.area}</td></tr>
      <tr><td>ApiKey</td><td>{detail.apiKey}</td></tr>
      <tr><td>営業担当者</td><td>{detail.canSell ? 'はい' : 'いいえ'}</td></tr>
      <tr><td>サポート担当者</td><td>{detail.canSupport ? 'はい' : 'いいえ'}</td></tr>
      </tbody>
    </table>
  );
}

export default (props) => {
  const [data, setData] = React.useState({});
  const history = useHistory();
  const location = useLocation();

  const id = props.match && props.match.params && props.match.params.id;

  React.useEffect(() => {
    apiclient.get(`api/coordinator/${id}`)
      .then(response => {
        setData({ detail: response.data, loaded: true });
      });
  }, [id]);

  const handleNewApiKey = React.useCallback(() => {
    apiclient.post(`api/coordinator/${id}/apikey`)
      .then(response => {
        alert(response.data.apiKey);
      });
  }, [id]);

  const contents = data.loaded
    ? <Table detail={data.detail} />
    : <p><em>Loading...</em></p>;

    return (
      <div>
        <h1 id="tabelLabel" ><span onClick={() => history.goBack()}>担当者一覧</span> &#12297; {id}</h1>
        <Button onClick={() => history.push(`${location.pathname}/edit`)}>編集</Button>
        <Button onClick={handleNewApiKey}>ApiKey更新</Button>
        {contents}
      </div>
    );
}